<template>
  <div>
    <div class="d-flex justify-content-center my-3">
      <h1 class="company-name"> {{ company && company.name }} </h1>
    </div>

    <b-container class="font">
      <!-- Company Details Section -->
      <b-row class="d-flex justify-content-center mx-2">
        <b-col class="col-2"></b-col>
        <!-- Left Column -->
        <b-col class="col-4">
          <div v-for="(data, key) in companyDetails" :key="key"
            class="row mb-1 d-flex align-items-center company-detail-row">
            <div class="col-4 font-weight-bolder text-left">{{ data.displayValue }}</div>
            <div class="col-8 company-field-title">
              {{ company && company[data.field] || '-' }}
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-4 font-weight-bolder text-left">News Letter</div>
            <div class="col-8"  @click="previewNewsLetter()">
              <div class="label label-inline label-dark-secondary font-weight-bolder py-4">
                Preview
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="col-6">
          <div v-for="(data, key) in adminDetails" :key="key"
            class="row mb-1 d-flex align-items-center company-detail-row">
            <div class="col-4 font-weight-bolder text-left">{{ data.displayValue }}</div>
            <div class="col-8 company-field-title">
              {{ company && company.admin_user && company.admin_user[data.field] || '-' }}
            </div>
          </div>

          <div class="row mb-1 d-flex align-items-center">
            <div class="col-4 font-weight-bolder text-left">Status</div>
            <div class="col-8 d-flex">
              <div style="padding-right: 3rem !important;">
                <b-form-checkbox v-model="company.active" @change="toggleActive" switch> </b-form-checkbox>
              </div>
              <div
                class="label label-inline label-light-danger font-weight-bolder py-4"
                v-if="!company.active"
                >
                INACTIVE
              </div>
              <div
                class="label label-inline label-light-success font-weight-bolder py-4"
                v-else
                >
                ACTIVE
              </div>
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="d-flex justify-content-between">
            <b-button class="btn-pill font-weight-bold mr-2" variant="dark" @click="generateBillingInvoice"
              :disabled="pdfloading">
              <span>Generate Billing Invoice</span>
            </b-button>
          </div>
          <Billing ref="billing-modal" />
          </div>
        </b-col>
      </b-row>
      <br><br>

      <!-- Settings Sections -->
      <b-row class="d-flex justify-content-center mx-2">
        <b-col v-for="(sectionData, sectionName) in sections" :key="sectionName" class="col-8 col-md-5 section-column">
          <settings-section 
            :company="company" 
            :sectionData="sectionData" 
            :sectionName="sectionName" 
            :editState="editState"
          />
        </b-col>
      </b-row>

      <br />

      <!-- Save & Cancel Buttons -->
      <b-row>
        <div class="d-flex justify-content-between mx-auto">
          <b-button class="btn-pill font-weight-bold mr-4" variant="dark" :disabled="disabled" @click="editBusiness">
            <span>Save</span>
          </b-button>
          <b-button class="btn-pill font-weight-bold" variant="dark" @click="moveToCompany">
            <span>Cancel</span>
          </b-button>
        </div>
      </b-row>
    </b-container>
    <newsletter ref="newsletter-modal" />
  </div>
</template>

<script>
import { SECTIONS, HEADER_SECTION } from '@/constants';
import CompaniesService from '@/services/companies.service';
import SettingsSection from './components/SettingsSection.vue';
import Newsletter from './components/newsletter.vue';

// import Billing from './billing.vue'
import Billing from './components/billing.vue';
export default {
  components: {
    SettingsSection,
    Newsletter,
    Billing
  },
  data() {
    return {
      company: null,
      originalCompanyObj: null,
      disabled: false,
      editState: {},
      sections: SECTIONS,
      companyDetails: HEADER_SECTION.companyDetails,
      adminDetails: HEADER_SECTION.adminDetails,
    };
  },
  mounted() {
    CompaniesService.get(this.$route.params.business_id)
      .then(({ data }) => {
        this.company = data;
        this.originalCompanyObj = JSON.parse(JSON.stringify(this.company));
      })
      .catch((err) => {
        console.log(err);
        this.$showAlert("Something went wrong!", 'danger');
      });
  },
  methods: {
    moveToCompany() {
      this.$router.push({ name: 'companies' });
    },
    editBusiness() {
      Object.keys(this.editState).forEach(field => {
        if (this.editState[field]) {
          this.resetBusinessField(field);
        }
      });
      const { pdf_brand_image, ...objToSend } = this.company;
      CompaniesService.patch(this.company.id, { ...objToSend })
        .then(() => this.moveToCompany())
        .catch((err) => console.log(err))
    },
    resetBusiness() {
      this.company = JSON.parse(JSON.stringify(this.originalCompanyObj));
    },
    resetBusinessField(field) {
      this.company[field] = this.originalCompanyObj[field];
    },
    toggleActive(event){
      this.company.allow_integrations = this.company.is_merchant == true ? event : false;
    },
    generateBillingInvoice() {
      this.$refs["billing-modal"].open(this.company);
    },
    previewNewsLetter(){
      if(this.company.send_monthly_newsletter == true){
        this.$refs["newsletter-modal"].open(this.company.id);
      }
      else{
        this.$showAlert('No subscription for newsletter', 'danger');
      }
      
    },
  }
};
</script>

<style scoped lang="scss">
@import "./CompanySettings.scss";
</style>
